import { locale } from 'dayjs'
import UserService from '../services/user.service'

export const userModule = {
  namespaced: true,

  state: {
    userResponse: null,
    user: null,
    localeChanged: false
  },

  actions: {
    async search ({ commit }, criterias) {
      return UserService.search(criterias).then(
        response => {
          const userResponse = response.data
          commit('searchSuccess', userResponse)
          return Promise.resolve(userResponse.users)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async initCreateUser ({ commit }, criterias) {
      return UserService.initCreateUser(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async create ({ commit }, criterias) {
      return UserService.create(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async initUserUpdate ({ commit }, criterias) {
      return UserService.initUserUpdate(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async edit ({ commit }, criterias) {
      return UserService.edit(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async delete ({ commit }, criterias) {
      return UserService.delete(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async lockUser ({ commit }, criterias) {
      return UserService.lockUser(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async unlockUser ({ commit }, criterias) {
      return UserService.unlockUser(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async resetOtp ({ commit }, criterias) {
      return UserService.resetOtp(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async reinitPwd ({ commit }, criterias) {
      return UserService.reinitPwd(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async setUser ({ commit }, user) {
      commit('userSuccess', user)
    },

    async setLocaleChanged ({ commit }, value) {
      commit('localeChanged', value)
    }
  },

  mutations: {
    loginSucess (state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure (state) {
      state.status.loggedIn = false
      state.user = null
    },
    searchSuccess (state, userResponse) {
      state.userResponse = userResponse
    },
    searchFailure (state) {
      state.userResponse = null
    },
    listReset (state) {
      state.userResponse = null
    },
    logoutSuccess (state) {
      state.status.loggedIn = false
      state.user = null
    },
    userSuccess (state, user) {
      state.user = user
    },
    localeChanged (state, value) {
      state.localeChanged = value
    }
  }
}
